// src/pages/services/PrivateJetCharter.js
import React, { useState } from 'react';
import Logo from '../../components/Logo';
import Footer from '../../components/Footer';
import WalletMenu from '../../components/WalletMenu';
import NavigationMenu from '../../components/NavigationMenu';
import { useAuth } from '../../context/AuthContext';
import { Search, X, Plus, ArrowRight, Info, Users, MapPin, Clock } from 'lucide-react';

const jetsData = [
  {
    id: "challenger 300",
    name: "CHALLENGER 300",
    description: "The Challenger 300 offers transcontinental range and comfort in the super-midsize class.",
    capacity: 9,
    range: 5000,
    speed: 850,
    price_per_hour: 9000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//Challenger%20300%2020182%20Exterior.jpg.webp",
    category: "Super Midsize Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "challenger 350",
    name: "CHALLENGER 350",
    description: "Bombardier’s Challenger 350 is efficient, quiet and luxurious for business missions.",
    capacity: 9,
    range: 5000,
    speed: 850,
    price_per_hour: 9000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//challenger-350.webp",
    category: "Super Midsize Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "challenger 604",
    name: "CHALLENGER 604",
    description: "Known for its durability, the Challenger 604 is a proven heavy jet with long-range capability.",
    capacity: 6,
    range: 2500,
    speed: 850,
    price_per_hour: 11750,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//Challenger%20604.webp",
    category: "Heavy Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "challenger 605",
    name: "CHALLENGER 605",
    description: "The Challenger 605 improves avionics and cabin over its predecessor, ideal for intercontinental travel.",
    capacity: 6,
    range: 2500,
    speed: 850,
    price_per_hour: 11750,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//challenger-605.2.webp",
    category: "Heavy Jet",
    availability: "Available",
    is_available: true
  },
  {
    id: "challenger 650",
    name: "CHALLENGER 650",
    description: "The latest in the Challenger line, the 650 offers top-tier comfort and global range.",
    capacity: 6,
    range: 2500,
    speed: 850,
    price_per_hour: 11750,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//reBrandCL650-1440x1080_0.jpg",
    category: "Heavy Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "challenger 850",
    name: "CHALLENGER 850",
    description: "Based on a CRJ200 regional airliner, the Challenger 850 delivers a spacious cabin and VIP configuration.",
    capacity: 6,
    range: 2500,
    speed: 850,
    price_per_hour: 11750,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//challgener850.jpg",
    category: "Heavy Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "global 5000",
    name: "GLOBAL 5000",
    description: "The Global 5000 offers speed, cabin comfort and global range in a reliable Bombardier platform.",
    capacity: 12,
    range: 10000,
    speed: 900,
    price_per_hour: 16250,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//global_6500.jpg",
    category: "Ultra Long Range Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "global 5500",
    name: "GLOBAL 5500",
    description: "A refined version of the 5000, the Global 5500 balances range and operational cost.",
    capacity: 6,
    range: 2500,
    speed: 900,
    price_per_hour: 16250,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//global5500.webp",
    category: "Ultra Long Range Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "global 6000",
    name: "GLOBAL 6000",
    description: "With luxurious cabin zones, the Global 6000 is ideal for high-profile global travelers.",
    capacity: 12,
    range: 10000,
    speed: 900,
    price_per_hour: 16250,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//GL-6000-Ext-JS.jpg",
    category: "Ultra Long Range Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "global 6500",
    name: "GLOBAL 6500",
    description: "A performance upgrade over the 6000, with new engines and extended range.",
    capacity: 6,
    range: 2500,
    speed: 900,
    price_per_hour: 16250,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//global_6500.jpg",
    category: "Ultra Long Range Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "global 7500",
    name: "GLOBAL 7500",
    description: "Bombardier's Global 7500 is the longest-range jet ever built with unmatched cabin layout.",
    capacity: 14,
    range: 13000,
    speed: 900,
    price_per_hour: 15500,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//global-7500-biggin_78990.jpg",
    category: "Ultra Long Range Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "global 8000",
    name: "GLOBAL 8000",
    description: "The Global 8000 aims to redefine long-haul travel with extreme range and advanced luxury.",
    capacity: 14,
    range: 13000,
    speed: 900,
    price_per_hour: 15500,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//bombardier-8000-2-1.avif",
    category: "Ultra Long Range Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "learjet 40",
    name: "LEARJET 40",
    description: "The Learjet 40 offers speed and compact luxury for quick regional hops.",
    capacity: 4,
    range: 2500,
    speed: 850,
    price_per_hour: 6000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//bombardier-learjet-40-02.jpg",
    category: "Light Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "learjet 40xr",
    name: "LEARJET 40XR",
    description: "An upgraded Learjet 40, the 40XR delivers more range and takeoff flexibility.",
    capacity: 4,
    range: 2500,
    speed: 850,
    price_per_hour: 6000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//Lear-40XR-Ext.jpg",
    category: "Light Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "learjet 45",
    name: "LEARJET 45",
    description: "Popular for business charters, the Learjet 45 combines speed and cabin efficiency.",
    capacity: 6,
    range: 1500,
    speed: 850,
    price_per_hour: 6000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//bombardier-learjet-40-02.jpg",
    category: "Light Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "learjet 45xr",
    name: "LEARJET 45XR",
    description: "With increased performance and payload, the 45XR is ideal for business trips.",
    capacity: 6,
    range: 1500,
    speed: 850,
    price_per_hour: 6000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//Lear-40XR-Ext.jpg",
    category: "Light Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "learjet 60",
    name: "LEARJET 60",
    description: "The Learjet 60 is a midsize classic with coast-to-coast reach and sporty performance.",
    capacity: 6,
    range: 3000,
    speed: 850,
    price_per_hour: 6000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//Lear-60-charter.webp",
    category: "Light Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "learjet 60xr",
    name: "LEARJET 60XR",
    description: "The 60XR is an updated version of the Learjet 60 with enhanced cockpit and cabin.",
    capacity: 6,
    range: 3000,
    speed: 850,
    price_per_hour: 6000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//Lear-60-charter.webp",
    category: "Light Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "learjet 75",
    name: "LEARJET 75",
    description: "A modern light jet with 8 seats, high speed, and stylish Bombardier interiors.",
    capacity: 6,
    range: 1500,
    speed: 850,
    price_per_hour: 6000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//Bombardier%20Learjet%2075%20Exterior.jpg",
    category: "Light Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "citation mustang",
    name: "CITATION MUSTANG",
    description: "The Citation Mustang is a cost-effective very light jet with comfort for short regional trips.",
    capacity: 4,
    range: 2500,
    speed: 800,
    price_per_hour: 5500,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//0512_Citation_Mustang.jpg",
    category: "Very Light Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "citation m2",
    name: "CITATION M2",
    description: "An evolution of the Mustang, the Citation M2 brings more speed and luxury to VLJ class.",
    capacity: 4,
    range: 2500,
    speed: 800,
    price_per_hour: 6000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//citationm2.jpg",
    category: "Light Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "citation cj1",
    name: "CITATION CJ1",
    description: "The CJ1 is a nimble jet perfect for short hops and efficient business travel.",
    capacity: 4,
    range: 2500,
    speed: 800,
    price_per_hour: 6000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//citation%20cj1.jpg",
    category: "Light Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "citation cj2",
    name: "CITATION CJ2",
    description: "The CJ2 adds speed and capacity to Cessna's CitationJet lineup.",
    capacity: 4,
    range: 2500,
    speed: 800,
    price_per_hour: 6000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//citation-cj2-1.jpg",
    category: "Light Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "citation cj3",
    name: "CITATION CJ3",
    description: "Known for its reliability, the CJ3 is a light jet favorite in Europe and the US.",
    capacity: 4,
    range: 2500,
    speed: 800,
    price_per_hour: 6000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//CJ3-PK.jpg",
    category: "Light Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "citation cj4",
    name: "CITATION CJ4",
    description: "The CJ4 is the largest in the CJ line, ideal for corporate flights with long legs.",
    capacity: 4,
    range: 2500,
    speed: 800,
    price_per_hour: 6000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//CJ4-CH-9.jpg",
    category: "Light Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "citation bravo",
    name: "CITATION BRAVO",
    description: "The Citation Bravo is a legacy light jet with solid performance and comfort.",
    capacity: 6,
    range: 2500,
    speed: 800,
    price_per_hour: 6000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//CJ3-PK.jpg",
    category: "Light Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "citation encore",
    name: "CITATION ENCORE",
    description: "Encore jets add extended range and upgraded interiors over earlier Citation models.",
    capacity: 6,
    range: 2500,
    speed: 800,
    price_per_hour: 6000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//Citation-Ultra.jpg",
    category: "Light Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "citation xls",
    name: "CITATION XLS",
    description: "The XLS is a midsize bestseller thanks to performance, reliability, and comfort.",
    capacity: 8,
    range: 4000,
    speed: 800,
    price_per_hour: 7250,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//citationxls.jpg",
    category: "Midsize Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "citation xls+",
    name: "CITATION XLS+",
    description: "An improved XLS+, offering upgraded cabin and avionics for midsize missions.",
    capacity: 8,
    range: 4000,
    speed: 800,
    price_per_hour: 7250,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//Cessna_Citation_XLS.jpg.webp",
    category: "Midsize Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "citation latitude",
    name: "CITATION LATITUDE",
    description: "The Citation Latitude offers a flat-floor cabin and coast-to-coast US range.",
    capacity: 6,
    range: 2500,
    speed: 800,
    price_per_hour: 9000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//cessna-citation-latitude.webp",
    category: "Super Midsize Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "citation sovereign",
    name: "CITATION SOVEREIGN",
    description: "A super midsize jet, the Sovereign provides range and climb unmatched in its class.",
    capacity: 8,
    range: 4000,
    speed: 800,
    price_per_hour: 7250,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//citationsovereign.avif",
    category: "Midsize Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "citation x",
    name: "CITATION X",
    description: "Cessna’s Citation X is one of the fastest business jets in the world.",
    capacity: 6,
    range: 2500,
    speed: 900,
    price_per_hour: 9000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//citationX.jpg",
    category: "Super Midsize Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "falcon 50",
    name: "FALCON 50",
    description: "The Falcon 50 is a tri-jet with flexible performance and solid cabin comfort.",
    capacity: 9,
    range: 5000,
    speed: 900,
    price_per_hour: 9000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//falcon_50-int-1.jpg",
    category: "Super Midsize Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "falcon 50ex",
    name: "FALCON 50EX",
    description: "An enhanced Falcon 50 with more range and digital flight systems.",
    capacity: 9,
    range: 5000,
    speed: 900,
    price_per_hour: 9000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//dassault-falcon-50-50ex.webp",
    category: "Super Midsize Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "falcon 2000",
    name: "FALCON 2000",
    description: "The Falcon 2000 is a popular midsize jet with excellent range and cabin volume.",
    capacity: 8,
    range: 4000,
    speed: 850,
    price_per_hour: 7250,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//falcon_2000LXS_2000px.jpg",
    category: "Midsize Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "falcon 2000s",
    name: "FALCON 2000S",
    description: "The 2000S improves short field performance and fuel efficiency.",
    capacity: 8,
    range: 4000,
    speed: 850,
    price_per_hour: 7250,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//dassault-falcon-2000s-banner-1.webp",
    category: "Midsize Jet",
    availability: "Available",
    is_available: true
  },
  {
    id: "falcon 2000lx",
    name: "FALCON 2000LX",
    description: "The 2000LX adds winglets for longer range and improved economy.",
    capacity: 8,
    range: 4000,
    speed: 850,
    price_per_hour: 7250,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//FA2000LXS-ext-JS.jpg",
    category: "Midsize Jet",
    availability: "Available",
    is_available: true
  },
  {
    id: "falcon 2000ex",
    name: "FALCON 2000EX",
    description: "EX models boost performance and payload for mid- to long-range missions.",
    capacity: 8,
    range: 4000,
    speed: 850,
    price_per_hour: 7250,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//dassault-falcon-2000ex-.webp",
    category: "Midsize Jet",
    availability: "Available",
    is_available: true
  },
  {
    id: "falcon 7x",
    name: "FALCON 7X",
    description: "A tri-jet with fly-by-wire controls, the 7X is fast, comfortable, and long-range.",
    capacity: 12,
    range: 10000,
    speed: 900,
    price_per_hour: 16250,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//Dassault-Falcon-7X-Ext_1.jpg",
    category: "Ultra Long Range Jet",
    availability: "Available",
    is_available: true
  },
  {
    id: "falcon 8x",
    name: "FALCON 8X",
    description: "Dassault’s flagship, offering extreme range and one of the quietest cabins.",
    capacity: 12,
    range: 10000,
    speed: 900,
    price_per_hour: 16250,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//dassault-falcon-8x-96-1745590059.webp",
    category: "Ultra Long Range Jet",
    availability: "Available",
    is_available: true
  },
  {
    id: "phenom 100",
    name: "PHENOM 100",
    description: "Entry-level jet by Embraer with great efficiency and comfort for 4 passengers.",
    capacity: 4,
    range: 2180,
    speed: 800,
    price_per_hour: 5500,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//phenom100.jpg",
    category: "Very Light Jet",
    availability: "Available",
    is_available: true
  },
  {
    id: "phenom 100e",
    name: "PHENOM 100E",
    description: "An enhanced Phenom 100 with upgraded avionics and comfort.",
    capacity: 4,
    range: 2180,
    speed: 800,
    price_per_hour: 5500,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//Embraer-Phenom-100-for-Charter-scaled.jpg",
    category: "Very Light Jet",
    availability: "Available",
    is_available: true
  },
  {
    id: "phenom 300",
    name: "PHENOM 300",
    description: "The Phenom 300 is a high-performing light jet with coast-to-coast range in the US.",
    capacity: 6,
    range: 1500,
    speed: 800,
    price_per_hour: 6000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//P300E-Bossa-Nova-Jay-Opt-scaled%20(1).jpg",
    category: "Light Jet",
    availability: "Available",
    is_available: true
  },
  {
    id: "phenom 300e",
    name: "PHENOM 300E",
    description: "The 300E offers ergonomic upgrades and a refined flight deck.",
    capacity: 6,
    range: 1500,
    speed: 800,
    price_per_hour: 6000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//phenom_300_1.jpg",
    category: "Light Jet",
    availability: "Available",
    is_available: true
  },
  {
    id: "legacy 450",
    name: "LEGACY 450",
    description: "The Legacy 450 is a modern midsize jet with fly-by-wire and flat-floor cabin.",
    capacity: 8,
    range: 4000,
    speed: 800,
    price_per_hour: 7250,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//embraer-legacy-450-3.webp",
    category: "Midsize Jet",
    availability: "Available",
    is_available: true
  },
  {
    id: "g280",
    name: "G280",
    description: "The G280 features Gulfstream design in a powerful and efficient platform.",
    capacity: 8,
    range: 4000,
    speed: 800,
    price_per_hour: 7250,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//gulfstreamG280.jpg",
    category: "Midsize Jet",
    availability: "Available",
    is_available: true
  },
  {
    id: "g450",
    name: "G450",
    description: "Popular among corporates, the G450 blends performance and luxury.",
    capacity: 12,
    range: 10000,
    speed: 900,
    price_per_hour: 16250,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//Gulfstream+G450+Production+To+End.jpg",
    category: "Ultra Long Range Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "g550",
    name: "G550",
    description: "With long range and quiet cabin, the G550 is a favorite of global travelers.",
    capacity: 12,
    range: 10000,
    speed: 900,
    price_per_hour: 16250,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//Gulfstream+Reinforces+Reliability+And+Capabilities+With+World+Speed+Record_resize.jpg",
    category: "Ultra Long Range Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "g650",
    name: "G650",
    description: "The G650 is a record-setting long-range business jet with ultra-luxury.",
    capacity: 14,
    range: 13000,
    speed: 900,
    price_per_hour: 15500,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//G650-Exterior.jpg",
    category: "Ultra Long Range Jet",
    availability: "Available",
    is_available: true
  },
  {
    id: "g700",
    name: "G700",
    description: "Gulfstream’s latest flagship, the G700, redefines ultra-long range travel.",
    capacity: 14,
    range: 13000,
    speed: 900,
    price_per_hour: 15500,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//d_g700_a_print_00141_PROD.jpg",
    category: "Ultra Long Range Jet",
    availability: "Available",
    is_available: true
  },
  {
    id: "hawker 400",
    name: "HAWKER 400",
    description: "The Hawker 400 is a compact light jet used widely for regional hops.",
    capacity: 4,
    range: 2500,
    speed: 800,
    price_per_hour: 6000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//hawker400xp.png",
    category: "Light Jet",
    availability: "Available",
    is_available: true
  },
  {
    id: "hondajet",
    name: "HONDAJET",
    description: "Modern very light jet with advanced aerodynamics and a quiet cabin for short-range missions.",
    capacity: 4,
    range: 2200,
    speed: 800,
    price_per_hour: 5500,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//hondajet.jpg",
    category: "Very Light Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "pc-12 ngx",
    name: "PC-12 NGX",
    description: "The PC-12 NGX is a turboprop workhorse with cabin comfort and short field capability.",
    capacity: 6,
    range: 1500,
    speed: 550,
    price_per_hour: 3850,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//0123943013v2.jpg",
    category: "Turboprop",
    availability: "Available",
    is_available: true
  },
  {
    id: "pc-24",
    name: "PC-24",
    description: "Pilatus’ twin-engine jet with cargo door and off-runway utility.",
    capacity: 6,
    range: 1500,
    speed: 800,
    price_per_hour: 6000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//PC24-1.jpg",
    category: "Light Jet",
    availability: "Available",
    is_available: true
  },
  {
    id: "avanti p180",
    name: "AVANTI P180",
    description: "Italian pusher-prop aircraft known for speed and efficiency.",
    capacity: 6,
    range: 1500,
    speed: 740,
    price_per_hour: 3850,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//FlightFX-P-180-Avanti-Microsoft-Flight-Simulator-7.webp",
    category: "Turboprop",
    availability: "on request",
    is_available: true
  },
  {
    id: "king air 90",
    name: "KING AIR 90",
    description: "King Air 90 is a reliable turboprop for short regional trips.",
    capacity: 6,
    range: 3000,
    speed: 550,
    price_per_hour: 6000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//kingair90.jpg",
    category: "Turboprop",
    availability: "Available",
    is_available: true
  },
  {
    id: "king air 200",
    name: "KING AIR 200",
    description: "Widely used for charter and medevac, it offers rugged utility and versatility.",
    capacity: 6,
    range: 3000,
    speed: 550,
    price_per_hour: 6000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//kingair200.webp",
    category: "Turboprop",
    availability: "Available",
    is_available: true
  },
  {
    id: "king air 350i",
    name: "KING AIR 350I",
    description: "The largest King Air model with modern interiors and extended range.",
    capacity: 6,
    range: 3000,
    speed: 550,
    price_per_hour: 6000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//beechcraft-king-air-300-350-1.webp",
    category: "Turboprop",
    availability: "no request",
    is_available: true
  },
  {
    id: "lineage 1000",
    name: "LINEAGE 1000",
    description: "Converted regional jet offering VIP cabin zones and global connectivity.",
    capacity: 6,
    range: 2500,
    speed: 850,
    price_per_hour: 16250,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//Embraer-Lineage-1000-for-Charter-scaled%20(1).jpg",
    category: "Ultra Long Range Jet",
    availability: "on request",
    is_available: true
  },
  {
    id: "g150",
    name: "G150",
    description: "A mid-light Gulfstream jet with performance and a compact cabin.",
    capacity: 8,
    range: 4000,
    speed: 800,
    price_per_hour: 7250,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//gulfstream-g150.webp",
    category: "Midsize Jet",
    availability: "Available",
    is_available: true
  },
  {
    id: "g200",
    name: "G200",
    description: "Delivers super midsize range and stand-up cabin comfort at a competitive price.",
    capacity: 8,
    range: 4000,
    speed: 800,
    price_per_hour: 7250,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//Gulfstream%20G200%20exterior%201.jpg",
    category: "Midsize Jet",
    availability: "Available",
    is_available: true
  },
  {
    id: "praetor 500",
    name: "PRAETOR 500",
    description: "A derivative of the Legacy 450 with improved range and advanced systems.",
    capacity: 8,
    range: 4000,
    speed: 800,
    price_per_hour: 7250,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//praetor500.webp",
    category: "Midsize Jet",
    availability: "Available",
    is_available: true
  },
  {
    id: "praetor 600",
    name: "PRAETOR 600",
    description: "Among the best-equipped super-midsize jets globally with exceptional performance.",
    capacity: 9,
    range: 5000,
    speed: 850,
    price_per_hour: 9000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//Flexjet-Praetor-600-Aircraft.avif",
    category: "Super Midsize Jet",
    availability: "Available",
    is_available: true
  },
  {
    id: "legacy 600",
    name: "LEGACY 600",
    description: "A longer-range Legacy with 13 passenger capacity and Embraer comfort.",
    capacity: 9,
    range: 5000,
    speed: 850,
    price_per_hour: 9000,
    image_url: "/images/jets/legacy-600.jpg",
    category: "Super Midsize Jet",
    availability: "Available",
    is_available: true
  },
  {
    id: "falcon 900ex",
    name: "FALCON 900EX",
    description: "Extended range version of the Falcon 900 for global operations.",
    capacity: 9,
    range: 5000,
    speed: 900,
    price_per_hour: 9000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//101.jpg",
    category: "Super Midsize Jet",
    availability: "Available",
    is_available: true
  },
  {
    id: "g350",
    name: "G350",
    description: "Large-cabin jet with intercontinental range and Gulfstream reliability.",
    capacity: 6,
    range: 2500,
    speed: 850,
    price_per_hour: 11750,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//gulfstream-g350.webp",
    category: "Heavy Jet",
    availability: "Available",
    is_available: true
  },
  {
    id: "legacy 650",
    name: "LEGACY 650",
    description: "Legacy 650 offers transatlantic range with fuel and payload upgrades.",
    capacity: 9,
    range: 5000,
    speed: 850,
    price_per_hour: 9000,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//Embraer650_-Header.jpg",
    category: "Super Midsize Jet",
    availability: "Available",
    is_available: true
  },
  {
    id: "hawker 800xp",
    name: "HAWKER 800XP",
    description: "Improved range and avionics over the standard Hawker 800 series.",
    capacity: 8,
    range: 4000,
    speed: 800,
    price_per_hour: 6500,
    image_url: "https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/public/jets0website0simon0emptylegs//65e0cd847da4668b290b6ea4_65ca13376348e831372dba04_Hawker-800-exterior.webp",
    category: "Midsize Jet",
    availability: "Available",
    is_available: true
  },
];

interface Jet {
  id: string;
  name: string;
  description: string;
  capacity: number;
  range: number;
  speed: number;
  price_per_hour: number;
  image_url: string;
  category: string;
  availability: string;
  is_available: boolean;
}

const PrivateJetCharter = () => {
  const { user } = useAuth();
  const [jets, setJets] = useState<Jet[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedJet, setSelectedJet] = useState<Jet | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterCategory, setFilterCategory] = useState('all');
  const [isAdmin, setIsAdmin] = useState(false);

  // Load admin status and jets
  React.useEffect(() => {
    checkAdminStatus();
    loadStaticJets();
  }, [user]);

  const checkAdminStatus = async () => {
    if (!user) return;
    try {
      setIsAdmin(user.email === 'admin@example.com');
    } catch (error) {
      console.error('Error checking admin status:', error);
    }
  };

  const loadStaticJets = () => {
    setTimeout(() => {
      setJets(jetsData);
      setLoading(false);
    }, 500);
  };

  const handleJetClick = (jet: Jet) => {
    setSelectedJet(jet);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedJet(null);
  };

  const filteredJets = jets.filter((jet) => {
    const matchesSearch = !searchTerm ||
      jet.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      jet.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
      jet.category.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesCategory = filterCategory === 'all' || jet.category.toLowerCase() === filterCategory.toLowerCase();

    return matchesSearch && matchesCategory;
  });

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-b from-gray-50 to-white border-b border-gray-100 shadow-sm">
        <div className="max-w-8xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-8">
            <Logo />
            <NavigationMenu />
          </div>
          <WalletMenu onShowDashboard={() => {}} />
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 pt-[88px] pb-16">
        <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8">
          {/* Hero Section */}
          <section className="text-center my-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Private Jet Charter</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Experience the ultimate in luxury air travel with our private jet charter services. Fly on your schedule to destinations worldwide with unparalleled comfort and convenience.
            </p>
          </section>

          {/* Search Bar */}
          <div className="mb-8 flex justify-center">
            <div className="relative max-w-md w-full">
              <Search size={20} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                placeholder="Search by name, category, or description..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black outline-none"
              />
              {searchTerm && (
                <button onClick={() => setSearchTerm('')} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
                  <X size={16} />
                </button>
              )}
            </div>
          </div>

          {/* Admin Add Button */}
          {isAdmin && (
            <div className="mb-6 flex justify-end">
              <a href="/admin/jets" className="inline-flex items-center gap-2 px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors">
                <Plus size={18} />
                <span>Add New Jet</span>
              </a>
            </div>
          )}

          {/* Filters */}
          <div className="flex flex-wrap justify-center gap-2 mb-8">
            <button
              onClick={() => setFilterCategory('all')}
              className={`px-4 py-2 rounded-lg ${filterCategory === 'all' ? 'bg-black text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'} transition-colors`}
            >
              All Jets
            </button>
            <button
              onClick={() => setFilterCategory('light')}
              className={`px-4 py-2 rounded-lg ${filterCategory === 'light' ? 'bg-black text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'} transition-colors`}
            >
              Light Jets
            </button>
            <button
              onClick={() => setFilterCategory('midsize')}
              className={`px-4 py-2 rounded-lg ${filterCategory === 'midsize' ? 'bg-black text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'} transition-colors`}
            >
              Midsize Jets
            </button>
            <button
              onClick={() => setFilterCategory('super')}
              className={`px-4 py-2 rounded-lg ${filterCategory === 'super' ? 'bg-black text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'} transition-colors`}
            >
              Super Midsize
            </button>
            <button
              onClick={() => setFilterCategory('large')}
              className={`px-4 py-2 rounded-lg ${filterCategory === 'large' ? 'bg-black text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'} transition-colors`}
            >
              Large Jets
            </button>
          </div>

          {/* Jet Grid */}
          {loading ? (
            <div className="flex justify-center items-center py-20">
              <div className="w-12 h-12 border-4 border-gray-200 border-t-black animate-spin rounded-full"></div>
            </div>
          ) : filteredJets.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredJets.map((jet) => (
                <div
                  key={jet.id}
                  className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-lg cursor-pointer border border-gray-100 group"
                  onClick={() => handleJetClick(jet)}
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={jet.image_url || 'https://via.placeholder.com/400x300 '}
                      alt={jet.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute top-3 left-3 bg-blue-500 text-white text-xs px-3 py-1 rounded-full">{jet.category}</div>
                  </div>
                  <div className="p-5">
                    <h3 className="text-lg font-bold mb-2">{jet.name}</h3>
                    <p className="text-sm text-gray-600 mb-3 line-clamp-2">{jet.description}</p>
                    <div className="flex flex-wrap gap-2 mb-4">
                      <div className="flex items-center text-xs bg-gray-100 px-2 py-1 rounded-full">
                        <Users size={14} className="mr-1" />
                        <span>{jet.capacity} passengers</span>
                      </div>
                      <div className="flex items-center text-xs bg-gray-100 px-2 py-1 rounded-full">
                        <MapPin size={14} className="mr-1" />
                        <span>{jet.range} km</span>
                      </div>
                      <div className="flex items-center text-xs bg-gray-100 px-2 py-1 rounded-full">
                        <Clock size={14} className="mr-1" />
                        <span>{jet.speed} km/h</span>
                      </div>
                    </div>
                    <div className="flex justify-between items-center">
                      <div className="text-lg font-bold">€{jet.price_per_hour.toLocaleString()}/h</div>
                      <button className="text-xs bg-black text-white px-3 py-1.5 rounded-lg hover:bg-gray-800 transition-colors">View Details</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-16 bg-gray-50 rounded-xl">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Info size={24} className="text-gray-400" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900">No jets found</h3>
              <p className="text-gray-500 mt-2">Try adjusting your search terms or filters.</p>
            </div>
          )}
        </div>
      </main>
      <Footer />

      {/* Modal */}
      {showModal && selectedJet && (
        <JetDetailModal jet={selectedJet} onClose={closeModal} />
      )}
    </div>
  );
};

// Dummy Modal Component
const JetDetailModal = ({ jet, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white max-w-2xl w-full max-h-[90vh] overflow-y-auto p-6 relative rounded-xl">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700">
          <X size={20} />
        </button>
        <img src={jet.image_url} alt={jet.name} className="w-full h-64 object-cover rounded-lg mb-6" />
        <h2 className="text-2xl font-bold mb-2">{jet.name}</h2>
        <p className="text-gray-600 mb-4">{jet.description}</p>
        <div className="grid grid-cols-2 gap-4 mb-6">
          <div className="bg-gray-100 p-3 rounded-lg">
            <span className="text-xs text-gray-500">Passengers</span>
            <p className="font-semibold">{jet.capacity}</p>
          </div>
          <div className="bg-gray-100 p-3 rounded-lg">
            <span className="text-xs text-gray-500">Range</span>
            <p className="font-semibold">{jet.range} km</p>
          </div>
          <div className="bg-gray-100 p-3 rounded-lg">
            <span className="text-xs text-gray-500">Speed</span>
            <p className="font-semibold">{jet.speed} km/h</p>
          </div>
          <div className="bg-gray-100 p-3 rounded-lg">
            <span className="text-xs text-gray-500">Price per hour</span>
            <p className="font-semibold">€{jet.price_per_hour.toLocaleString()}</p>
          </div>
        </div>
        <form className="space-y-4">
          <input type="text" placeholder="Your Name" className="w-full px-4 py-2 border border-gray-300 rounded-lg" required />
          <input type="email" placeholder="Email Address" className="w-full px-4 py-2 border border-gray-300 rounded-lg" required />
          <textarea rows={4} placeholder="Flight details, dates, destinations..." className="w-full px-4 py-2 border border-gray-300 rounded-lg" required></textarea>
          <button type="submit" className="w-full bg-black text-white py-3 rounded-lg hover:bg-gray-800 transition-colors">Submit Request</button>
        </form>
      </div>
    </div>
  );
};

export default PrivateJetCharter;